import UsersTechnology from '../models/UsersTechnology'
import { EmployeeStatus, Leader, Role } from '..'
import { Dayjs } from 'dayjs'

export type UserFormValues = {
  firstName: string
  lastName: string
  email: string
  birthDate: Dayjs | null
  student: boolean
  employeeStatus: EmployeeStatus
  phoneNumber: string
  technologies: UsersTechnology[] | undefined
  leaders: Leader[] | undefined
  avatar: string
  extension: string
  roles: Role[] | undefined
  vacationDays: string
  employmentPercentage: string
  paidVacation: boolean
}

export const defaultUserFormValues: UserFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  birthDate: null,
  student: false,
  employeeStatus: 'ACTIVE',
  phoneNumber: '',
  technologies: [],
  leaders: [],
  avatar: '',
  extension: '',
  roles: [],
  vacationDays: '0',
  employmentPercentage: '100',
  paidVacation: false,
}
